<div mat-dialog-title>
  Forgot Password
  <span class="float-right pointer" (click)="close()">
    <i class="fa fa-times close-btn "></i>
  </span>
</div>
<div mat-dialog-content>
  <h6 class=" text-center alert alert-success"
    *ngIf="message && message.topText && isOTPSendSuccessfully && !isOTPVariedSuccessfully">{{message &&
    message.topText}}</h6>
  <!-- <img *ngIf="isOTPSendSuccessfully==true" src="assets/download.jpg"
        style="width:150px;height:180px;margin-left:25px"> -->
  <!-- <h5 class=" text-center" *ngIf="invalid==true">Please Fill the Field</h5> -->
  <form [formGroup]="password_form">

    <!-- <div class="row " > -->
    <!-- <div class="col-md-12"> -->
    <div class="row form-group">
      <!-- <div class="col-md-4" *ngIf="is_mobile_number">
        <tm-select [form_group]="password_form" [form_control]="'mobileIsd'" [id_property]="'dial_code'"
          [title_property]="'countryName'" [options]="masters.countryList"
          [label]="'FORGOT_PASSWORD.mobileIsd' |translate" [placeholder]="'<- - Select - ->'"
          (selected_obj)="countryCodeChanged($event)"> </tm-select>
      </div> -->
      <div [class]="'col-md-12'">
        <!-- <app-phone-number [form]="login_form" [label]="'Mobile number'"
                [placeholder]="'Enter mobile number'" [material_ui]="1" [controlName]="'mobileNumber'"
                [value]="login_form.value.mobileNumber"></app-phone-number> -->
        <mat-form-field>
          <mat-label>{{"FORGOT_PASSWORD.mobileNumber" |translate}}</mat-label>
          <!-- <app-phone-number [form]="login_form" [controlName]="'mobileNumber'"></app-phone-number> -->
          <input type="text" required [disabled]="isOTPSendSuccessfully" matInput formControlName="loginId"
            [placeholder]="'FORGOT_PASSWORD.enter_mobile_number' |translate"
            [maxLength]=" validType =='mobileNumber' ?max_length:100">
          <mat-error>
            {{"FORGOT_PASSWORD.mobileNumber" |translate}} {{"ERROR.field_is_mandatory" |translate}}
          </mat-error>
        </mat-form-field>
        <!-- <input type="text" class="form-control" formControlName="username" placeholder="Username"> -->
      </div>
    </div>

    <div class="row form-group" *ngIf="isOTPSendSuccessfully">
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>
            {{"FORGOT_PASSWORD.verification_code" |translate}}
          </mat-label>
          <input required formControlName="otp" maxlength="6" type="text" [disabled]="isOTPVariedSuccessfully"
            [placeholder]='"FORGOT_PASSWORD.enter_verfication_code" |translate' matInput>
          <mat-error>
            {{"FORGOT_PASSWORD.verification_code" |translate}} {{"ERROR.field_is_mandatory" |translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row form-group" *ngIf="isOTPVariedSuccessfully">
      <div class="col-md-12">
        <mat-form-field>
          <mat-label> {{'FORGOT_PASSWORD.password'|translate}}</mat-label>
          <input autocomplete="new-password" required="true" [type]="!hide ? 'password' : 'text'" matInput
            placeholder="{{'FORGOT_PASSWORD.enter_new_password'|translate}}" formControlName="password"
            autocomplete="off" name="newPass" />
          <i matSuffix style="font-size: larger;" class="pointer" *ngIf="hide" class="fa fa-eye pointer"
            (click)="hide = !hide"></i>
          <i matSuffix style="font-size: larger;" class="pointer" *ngIf="!hide" class="fa fa-eye-slash pointer"
            (click)="hide = !hide"></i>
          <mat-error *ngIf="password_form.controls.password.errors">
            <div ngClass="fval.password.errors.required"
              *ngIf="password_form.controls.password.errors.required; else minLength">
              {{'ERROR.password_is_required' | translate}}
            </div>
            <ng-template #minLength>
              <div *ngIf="password_form.controls.password.errors.minlength;else invalid_input">
                {{'ERROR.password_must_be_at_least_6_characters' | translate}}
              </div>
            </ng-template>
            <ng-template #invalid_input>
              <div *ngIf="password_form.controls.password.errors?.pattern">
                {{"ERROR.password_input_invalid" |translate}}
              </div>
            </ng-template>
          </mat-error>

        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>{{'FORGOT_PASSWORD.newPassword'|translate}}</mat-label>
          <input autocomplete="new-password" required="true" [type]="!hide_confirm_pass ? 'password' : 'text'" matInput
            [placeholder]="'FORGOT_PASSWORD.newPassword'|translate" formControlName="newPassword" autocomplete="off"
            name="confirmPass" [errorStateMatcher]="matcher" />
          <i matSuffix style="font-size: larger;" class="pointer" *ngIf="hide_confirm_pass" class="fa fa-eye pointer"
            (click)="hide_confirm_pass = !hide_confirm_pass"></i>
          <i matSuffix style="font-size: larger;" class="pointer" *ngIf="!hide_confirm_pass"
            class="fa fa-eye-slash pointer" (click)="hide_confirm_pass = !hide_confirm_pass"></i>
          <mat-error *ngIf="password_form.controls.newPassword.hasError('notSame')">
            <div *ngIf="password_form.controls.newPassword.errors.required">
              {{'ERROR.re-enter_password_required' | translate}}
            </div>
            <div *ngIf="password_form.controls.newPassword.errors.minlength">
              {{'ERROR.password_must_be_at_least_6_characters' | translate}}
            </div>
            <div *ngIf="password_form.controls.newPassword.errors?.pattern">
              {{"ERROR.password_input_invalid" |translate}}
            </div>
            <div *ngIf="password_form.controls.newPassword.errors?.notSame">
              {{'ERROR.password_mismatch' | translate}}
            </div>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="form-group">
      <mat-form-field floatLabel="always">
        <mat-label>Username</mat-label>
        <input class="w-93" formControlName="login_id" matInput placeholder="Enter your username"
          [required]="password_form.value.login_id!=null">
        <mat-error *ngIf="password_form.controls.login_id.touched && password_form.controls.login_id.errors?.required">
          Please enter your username</mat-error>
      </mat-form-field>
    </div> -->

    <!-- </div> -->
    <!-- </div> -->


  </form>

</div>
<div mat-dialog-actions>
  <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

  <button class="blob-btn btn" style="min-width: 120px; float: left;"
    *ngIf="isOTPSendSuccessfully && !isOTPVariedSuccessfully" (click)="resendOTP()" [disabled]="countdown > 0">
    {{"FORGOT_PASSWORD.resend_otp" |translate}}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>
  <span class="pl-1" *ngIf="countdown > 0" style="color: rgb(194, 0, 0);">Time remaining : {{ countdown }}</span>

  <button class="ml-auto blob-btn-cancel btn mx-1" style="min-width: 120px;" (click)="close()">
    Close
    <span class="blob-btn-cancel__inner">
      <span class="blob-btn-cancel__blobs">
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
        <span class="blob-btn-cancel__blob"></span>
      </span>
    </span>
  </button>
  <button class="blob-btn btn " style="min-width: 120px;" *ngIf="!isOTPSendSuccessfully && !isOTPVariedSuccessfully"
    type="submit" (click)="save()">
    {{"FORGOT_PASSWORD.find_my_account" |translate}}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>

  <button class="blob-btn btn" style="min-width: 120px;" *ngIf="isOTPSendSuccessfully && !isOTPVariedSuccessfully"
    (click)="verifyOTP()">
    {{"FORGOT_PASSWORD.verify_otp" |translate}}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>

  <button class="blob-btn btn" style="min-width: 120px;" *ngIf="isOTPSendSuccessfully && isOTPVariedSuccessfully"
    (click)="changePassword()">
    {{"FORGOT_PASSWORD.submit" |translate}}
    <span class="blob-btn__inner">
      <span class="blob-btn__blobs">
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
        <span class="blob-btn__blob"></span>
      </span>
    </span>
  </button>

  <!-- <button (click)="close()" class="btn js-btn-cancel" style="min-width: 120px;">
      Close
    </button> -->

</div>
<!-- padding: 9px 0px 29px 0px; -->